export enum Variants {
  PERMANENT = 'permanent',
  PERSISTENT = 'persistent',
  TEMPORARY = 'temporary',
}
